import {
  Component, EventEmitter, Input, OnDestroy, OnInit, Output
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import {
  ProdutoGrupoModificadorConsultaDTO,
} from '../../../../../../../models/cardapio-minishop/cardapio-minishop.model';

@Component({
  selector: 'app-modificador-secao',
  templateUrl: './modificador-secao.component.html',
  styleUrls: ['./modificador-secao.component.scss'],
})
export class ModificadorSecaoComponent implements OnInit, OnDestroy {

  @Input() gruposAssociados: ProdutoGrupoModificadorConsultaDTO[] = [];
  @Input() produtoId = 0;
  @Input() loading = false;

  @Output() desassociarGrupo = new EventEmitter<number>();
  @Output() reordenarGrupos = new EventEmitter<number[]>();
  @Output() abrirGestaoModal = new EventEmitter<void>();
  @Output() grupoAtualizado = new EventEmitter<void>();

  texts = {
    titulo: '',
    descricao: '',
    adicionar_modificador: '',
    obrigatorio: '',
    opcional: '',
    opcoes: '',
    nenhum: '',
    confirmar_desassociar: '',
  };

  private langChangeSub!: Subscription;

  constructor(private translate: TranslateService) {}

  ngOnInit(): void {
    this.loadTranslations();
    this.langChangeSub = this.translate.onLangChange.subscribe(() => {
      this.loadTranslations();
    });
  }

  ngOnDestroy(): void {
    if (this.langChangeSub) this.langChangeSub.unsubscribe();
  }

  onDesassociar(associacaoId: number): void {
    this.desassociarGrupo.emit(associacaoId);
  }

  onAbrirGestao(): void {
    this.abrirGestaoModal.emit();
  }

  onDrop(event: CdkDragDrop<ProdutoGrupoModificadorConsultaDTO[]>): void {
    if (event.previousIndex === event.currentIndex) return;
    moveItemInArray(this.gruposAssociados, event.previousIndex, event.currentIndex);
    const ids = this.gruposAssociados.map(g => g.id);
    this.reordenarGrupos.emit(ids);
  }

  getQtdOpcoes(assoc: ProdutoGrupoModificadorConsultaDTO): number {
    return assoc.grupoModificador?.opcoes?.length || 0;
  }

  trackById(index: number, item: ProdutoGrupoModificadorConsultaDTO): number {
    return item.id;
  }

  private loadTranslations(): void {
    const base = 'cardapio_minishop.modificador';
    this.texts = {
      titulo: this.translate.instant(`${base}.titulo`),
      descricao: this.translate.instant(`${base}.descricao`),
      adicionar_modificador: this.translate.instant(`${base}.adicionar_modificador`),
      obrigatorio: this.translate.instant(`${base}.obrigatorio`),
      opcional: this.translate.instant(`${base}.opcional`),
      opcoes: this.translate.instant(`${base}.opcoes`),
      nenhum: this.translate.instant(`${base}.nenhum`),
      confirmar_desassociar: this.translate.instant(`${base}.confirmar_desassociar`),
    };
  }
}
